export function getStepsInRow(resolution) {
    return resolution.isTriplet ? 12 : 16;
}
